import Vue from 'vue';
import router from '@/router';
import axios from 'axios';
import App from '@/App.vue';
import VueApexCharts from 'vue-apexcharts';
import VueNoty from 'vuejs-noty';
import store from '@/store/index';
import vuetify from '@/plugins/vuetify';
import '@/plugins/firebase';
import firebase from 'firebase/app';
import AsyncComputed from 'vue-async-computed';

Vue.use(AsyncComputed)
Vue.use(VueNoty);
Vue.prototype.$http = axios;
Vue.use(VueApexCharts);
Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      store,
      router,
      vuetify,
      render: h => h(App),
    }).$mount('#app');
  }
})